module.exports = __webpack_public_path__ + "static/img/icon-03.8f522f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-it-works/icon-03.png
// module id = 21tc
// module chunks = 1